<template>
    <div class="pcr-admin container">
        <el-row>
            <el-col :span="24">
                <pcr-current-title :current="current"></pcr-current-title>
            </el-col>
            <el-col :span="24">
                <pcr-breadcrumb :current="current" style="margin-bottom: 12px;"></pcr-breadcrumb>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="8">
                <pcr-establishment-tree @change-current="changeCurrent" ref="pcr-tree"></pcr-establishment-tree>
            </el-col>
            <el-col :span="16">
                <admin-establishment-contextual-menu :current="current" ref="contextual-menu"></admin-establishment-contextual-menu>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import Vue from 'vue';
export default Vue.component('admin-index', {
    data() {
        return {
            current: null
        }
    },
    mounted: function() {
        setInterval(() => {
            if (this.$refs['pcr-tree'].$el.clientHeight != this.$refs['contextual-menu'].$el.clientHeight) {
                this.$refs['pcr-tree'].$el.style.height = (this.$refs['contextual-menu'].$el.clientHeight - $('#tree-search-input').height()) + 'px';
            }
        }, 100);
    },
    methods: {
        changeCurrent(current) {
            this.current = current;
        }
    },
    watch: {
    }
});
</script>

<style>
.pcr-admin {
    margin-top: 12px;
    width: 95%;
    min-width: 940px;
    min-height: 500px;
}

.el-table__empty-block {
    height: initial;
}

.el-tree {
    min-height: 400px;
    height: 100%;
    overflow-x: auto;
}
.pcr-admin-establishment-contextual-menu {
    min-height: 436px;
}
.pcr-admin-establishment-contextual-menu>.el-row {
    min-height: 436px;
}
.pcr-admin-establishment-contextual-menu>.el-row>.el-col {
    min-height: 436px;
}
.pcr-admin-establishment-contextual-menu>.el-row>.el-col .el-tabs {
    min-height: 436px;
}

.icon-action-right {
    height: 22px;
    line-height: 24px;
    cursor: pointer;
    float: right;
    font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/admin-index.vue